import SalesOrderIcon from './SalesOrderIcon';

export default SalesOrderIcon;
